export default __webpack_public_path__ + "static/media/photo--sm--67.6350da7d.jpg";